// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  organizationId: __t.string(),
  companyName: __t.string(),
  billingEmail: __t.string(),
  addressLine1: __t.string(),
  addressLine2: __t.string(),
  city: __t.string(),
  state: __t.string(),
  postalCode: __t.string(),
  certificateKey: __t.string(),
};
